import React, { useState } from 'react';
import axios from 'axios';

const VerifyEmailBanner: React.FC<{ email: string }> = ({ email }) => {
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');

  const handleResend = async () => {
    setStatus('sending');
    try {
      await axios.post('/api/auth/resend-verification', { email });
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="mb-4 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <p className="text-sm text-amber-200">
        Please verify your email address. We sent a verification link to{' '}
        <span className="font-semibold">{email}</span>.
      </p>
      <div className="flex items-center gap-3 shrink-0">
        {status === 'sent' ? (
          <span className="text-sm text-emerald-300">Verification email sent — check your inbox.</span>
        ) : (
          <button
            onClick={handleResend}
            disabled={status === 'sending'}
            className="text-sm font-semibold text-amber-300 hover:text-amber-100 underline disabled:opacity-50"
          >
            {status === 'sending' ? 'Sending…' : 'Resend verification email'}
          </button>
        )}
        {status === 'error' && (
          <span className="text-sm text-red-300">Couldn't send — try again later.</span>
        )}
      </div>
    </div>
  );
};

export default VerifyEmailBanner;
